import { memo } from 'react';

import type { DataEditorData } from '@/components/ui/dataEditor/dataEditor.type';
import type { DataImporterData } from '@/components/ui/dataImporter/dataImporter.type';
import { KeyValue } from '@/components/ui/keyValue/keyValue';
import type { TraceAction } from '@/types/workflow.types';
import { DataEditorReader } from './dataEditorReader';
import { DataImporterReader } from './dataImporterReader';

type Props = {
  action: TraceAction;
  data: DataEditorData | DataImporterData;
};

export const DataActionReader = memo(({ action, data }: Props) => {
  // switches between dataEditorReader and dataImporter reader and factorizes commments
  const dataTool = action.dataImporter || action.dataEditor;

  // comments data
  const { commentsKey = 'comments', commentsTitle = 'Comments' } =
    dataTool || {};
  const comments: Maybe<string> = data[commentsKey];

  const renderDataReader = () => {
    if (action.dataImporter) {
      return (
        <DataImporterReader
          data={data as DataImporterData}
          dataImporter={action.dataImporter}
        />
      );
    }
    if (action.dataEditor) {
      return (
        <DataEditorReader
          data={data as DataEditorData}
          dataEditor={action.dataEditor}
        />
      );
    }
    console.error('No data tool found in action:', action);
    return <div>No data tool found.</div>;
  };

  return (
    <div className="flex flex-col flex-nowrap gap-5">
      {renderDataReader()}
      {comments && (
        <KeyValue dataCyName="table-reader-comment" title={commentsTitle}>
          {comments}
        </KeyValue>
      )}
    </div>
  );
});
